import CaseNavbar from './components/CaseNavbar';
import CaseHero from './components/CaseHero';
import CaseChallenge from './components/CaseChallenge';
import CaseStrategy from './components/CaseStrategy';
import CaseMetrics from './components/CaseMetrics';
import CaseCharts from './components/CaseCharts';
import CaseTestimonial from './components/CaseTestimonial';
import CaseCTA from './components/CaseCTA';
import FooterSection from '../home/components/FooterSection';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';

export default function CaseStudyPage() {
  return (
    <main className="min-h-screen bg-zinc-950 font-sans">
      <CaseNavbar />
      <CaseHero />
      <CaseChallenge />
      <CaseStrategy />
      <CaseMetrics />
      <CaseCharts />
      <CaseTestimonial />
      <CaseCTA />
      <FooterSection />
      <FloatingWhatsApp />
    </main>
  );
}
